import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Tooltip, Button, DatePicker } from "antd";
import { connect } from "dva";
import moment from "moment";
import { router } from "umi";
import ListPage from "../../../../../../components/ListPage";
import OperateDropdown from "../../../../../../components/OperateDropdown";
import { GetQueryString } from "../../../../../../utils/utils";
import { getComposeUrl } from "../../../../../../utils/common";
import { url } from "../../../../../../services/service-utils";
import useRequest from "../../hooks/use-table-state";
import styles from "./index.less";

const { ListTable } = ListPage;
let searchDate = moment().subtract(1, "days");

const DailyStatisticList = props => {
  const appId = GetQueryString("appId") || 40;
  const activityBizId = GetQueryString("activityBizId");
  const nodeId = GetQueryString("nodeId") || "";
  const date = GetQueryString("date") || "";
  const { currentUser, isDetail, request } = props;
  const { orgType } = currentUser || {};
  const history = useHistory();

  const [newNodeId, setNodeId] = useState(nodeId || "");
  const [nowDate, setNowDate] = useState(
    date ||
      moment()
        .subtract(1, "days")
        .format("YYYY.MM.DD")
  );

  const {
    pageInfo,
    list,
    loading,
    handlePaginationChange,
    handleQueryChange
  } = useRequest(request, {
    initParams: {
      page: 1,
      pageSize: 10,
      // date: moment(searchDate).format("YYYY.MM.DD"),
      date: nowDate,
      activityBizId,
      nodeId: isDetail ? nodeId : ""
    }
  });

  useEffect(() => {
    if (history && history.listen) {
      const listenCB = history.listen(historyLocation => {
        const { query } = historyLocation;
        const { nodeId: newNode } = query || {};
        setNodeId(newNode);
        return listenCB;
      });
    }
  }, [history]);

  useEffect(() => {
    if (isDetail) {
      handleQueryChange({ query: { nodeId: newNodeId } });
    }
  }, [newNodeId]);

  const handleJump = record => {
    const { pathname } = window.location;
    const { nodeId: jumpNodeId } = record;
    if (isDetail) {
      router.push(
        getComposeUrl(
          `/activitySign/dataStatistic/dailyStatistic/bureauDailyStatistic/${jumpNodeId}?activityBizId=${activityBizId}&nodeId=${jumpNodeId}&date=${nowDate}&appId=${appId}`
        )
      );
    } else {
      router.push(
        getComposeUrl(
          `${pathname}/bureauDailyStatistic/${jumpNodeId}?activityBizId=${activityBizId}&nodeId=${jumpNodeId}&date=${nowDate}&appId=${appId}`
        )
      );
    }
  };

  const handleDateChange = (date, dateString) => {
    // searchDate = moment(date);
    setNowDate(dateString);
    handleQueryChange({ query: { date: dateString } });
  };

  const columns = [
    {
      title: "日期",
      dataIndex: "dateTime",
      key: "dateTime",
      width: 120,
      fixed: "left"
    },
    {
      title: orgType === "school" ? "班级" : "分组",
      dataIndex: "nodeName",
      key: "nodeName",
      width: 180,
      fixed: "left",
      render: deptName =>
        deptName && deptName.length ? (
          <Tooltip placement="top" title={deptName}>
            <span>
              {deptName.length <= 20
                ? deptName
                : `${deptName.substring(0, 20)}...`}
            </span>
          </Tooltip>
        ) : (
          "-"
        )
    },
    {
      title: "活动总人数",
      dataIndex: "totalNum",
      key: "totalNum",
      width: 120
    },
    {
      title: "打卡总人数",
      dataIndex: "actionNum",
      key: "actionNum",
      width: 120
    },
    {
      title: "打卡总次数",
      dataIndex: "actionSum",
      key: "actionSum",
      width: 120
    },
    {
      title: "未打卡人数",
      dataIndex: "noActionNum",
      key: "noActionNum",
      width: 120
    },
    {
      title: "总打卡率",
      dataIndex: "actionRatio",
      key: "actionRatio",
      width: 120,
      render: actionRatio => `${Math.round(actionRatio * 10000) / 100}%`
    },
    {
      title: "打卡学生数",
      dataIndex: "actionStuNum",
      key: "actionStuNum",
      width: 120
    },
    {
      title: "学生打卡次数",
      dataIndex: "actionStuSum",
      key: "actionStuSum",
      width: 120
    },
    {
      title: "未打卡学生数",
      dataIndex: "noActionStuNum",
      key: "noActionStuNum",
      width: 120
    },
    {
      title: "学生打卡率",
      dataIndex: "stuActionRatio",
      key: "stuActionRatio",
      width: 120,
      render: stuActionRatio => `${Math.round(stuActionRatio * 10000) / 100}%`
    },
    {
      title: "打卡教师数",
      dataIndex: "actionTeaNum",
      key: "actionTeaNum",
      width: 120
    },
    {
      title: "教师打卡次数",
      dataIndex: "actionTeaSum",
      key: "actionTeaSum",
      width: 120
    },
    {
      title: "未打卡教师数",
      dataIndex: "noActionTeaNum",
      key: "noActionTeaNum",
      width: 120
    },
    {
      title: "教师打卡率",
      dataIndex: "teaActionRatio",
      key: "teaActionRatio",
      width: 120,
      render: teaActionRatio => `${Math.round(teaActionRatio * 10000) / 100}%`
    },
    {
      title: "总评论人数",
      dataIndex: "commentNum",
      key: "commentNum",
      width: 120
    },
    {
      title: "总评论次数",
      dataIndex: "commentSum",
      key: "commentSum",
      width: 120
    },
    {
      title: "学生评论人数",
      dataIndex: "commentStuNum",
      key: "commentStuNum",
      width: 120
    },
    {
      title: "学生评论次数",
      dataIndex: "commentStuSum",
      key: "commentStuSum",
      width: 120
    },
    {
      title: "教师评论人数",
      dataIndex: "commentTeaNum",
      key: "commentTeaNum",
      width: 120
    },
    {
      title: "教师评论次数",
      dataIndex: "commentTeaSum",
      key: "commentTeaSum",
      width: 120
    },
    {
      title: "总点赞人数",
      dataIndex: "likeNum",
      key: "likeNum",
      width: 120
    },
    {
      title: "总点赞次数",
      dataIndex: "likeSum",
      key: "likeSum",
      width: 120
    },
    {
      title: "学生点赞人数",
      dataIndex: "likeStuNum",
      key: "likeStuNum",
      width: 120
    },
    {
      title: "学生点赞次数",
      dataIndex: "likeStuSum",
      key: "likeStuSum",
      width: 120
    },
    {
      title: "教师点赞人数",
      dataIndex: "likeTeaNum",
      key: "likeTeaNum",
      width: 120
    },
    {
      title: "教师点赞次数",
      dataIndex: "likeTeaSum",
      key: "likeTeaSum",
      width: 120
    },
    {
      title: "总收藏人数",
      dataIndex: "collectNum",
      key: "collectNum",
      width: 120
    },
    {
      title: "总收藏次数",
      dataIndex: "collectSum",
      key: "collectSum",
      width: 120
    },
    {
      title: "学生收藏人数",
      dataIndex: "collectStuNum",
      key: "collectStuNum",
      width: 120
    },
    {
      title: "学生收藏次数",
      dataIndex: "collectStuSum",
      key: "collectStuSum",
      width: 120
    },
    {
      title: "教师收藏人数",
      dataIndex: "collectTeaNum",
      key: "collectTeaNum",
      width: 120
    },
    {
      title: "教师收藏次数",
      dataIndex: "collectTeaSum",
      key: "collectTeaSum",
      width: 120
    },
    {
      title: "操作",
      key: "action",
      width: 160,
      fixed: "right",
      render: record => {
        const data = [
          {
            text: <a onClick={() => handleJump(record)}>详情</a>
          }
        ];
        return <OperateDropdown data={data} />;
      }
    }
  ];

  if (
    orgType === "school" &&
    columns.find(item => item.title === "操作" || orgType === "school")
  ) {
    columns.pop();
  }

  const listPageProps = {
    spinProps: {
      spinning: loading
    }
  };

  const tableProps = {
    columns,
    list,
    pageInfo,
    onPageChange: handlePaginationChange
  };

  return (
    <ListPage {...listPageProps}>
      <div
        className={styles.root}
        style={{ justifyContent: !isDetail ? "space-between" : "flex-end" }}
      >
        {!isDetail && (
          <DatePicker
            onChange={handleDateChange}
            format="YYYY.MM.DD"
            value={moment(nowDate, "YYYY/MM/DD")}
          />
        )}
        <Button
          type="primary"
          href={
            isDetail
              ? `${url.activitySign}/activity/item/download/exportDaySummary?activityBizId=${activityBizId}&date=${nowDate}&nodeId=${nodeId}&appId=${appId}`
              : `${url.activitySign}/activity/item/download/exportDaySummary?activityBizId=${activityBizId}&date=${nowDate}&appId=${appId}`
          }
          style={{
            marginTop: !isDetail ? 0 : 15
          }}
        >
          导出
        </Button>
      </div>
      <ListTable {...tableProps} />
    </ListPage>
  );
};

export default connect(({ user }) => ({
  ...user
}))(DailyStatisticList);
